import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuiaCSSBuySheet from "../pages/guia-cssbuy-sheet/page";
import MelhoresLinksCSSBuy from "../pages/melhores-links-cssbuy/page";
import VendedoresCSSBuyConfiaveis from "../pages/vendedores-cssbuy-confiaveis/page";
import CSSBuyGuiaSeguranca from "../pages/cssbuy-guia-seguranca/page";
import CSSBuyYupooGuide from "../pages/cssbuy-yupoo-guide/page";
import StreetwearSpreadsheetGuide from "../pages/streetwear-spreadsheet-guide/page";
import ReplicaSneakersGuia from "../pages/replica-sneakers-guia/page";
import CSSBuyShippingGuide from "../pages/cssbuy-shipping-guide/page";
import CSSBuyVsOutrosAgentes from "../pages/cssbuy-vs-outros-agentes/page";
import CSSBuyDicasIniciantes from "../pages/cssbuy-dicas-iniciantes/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/guia-cssbuy-sheet", element: <GuiaCSSBuySheet /> },
  { path: "/melhores-links-cssbuy", element: <MelhoresLinksCSSBuy /> },
  { path: "/vendedores-cssbuy-confiaveis", element: <VendedoresCSSBuyConfiaveis /> },
  { path: "/cssbuy-guia-seguranca", element: <CSSBuyGuiaSeguranca /> },
  { path: "/cssbuy-yupoo-guide", element: <CSSBuyYupooGuide /> },
  { path: "/streetwear-spreadsheet-guide", element: <StreetwearSpreadsheetGuide /> },
  { path: "/replica-sneakers-guia", element: <ReplicaSneakersGuia /> },
  { path: "/cssbuy-shipping-guide", element: <CSSBuyShippingGuide /> },
  { path: "/cssbuy-vs-outros-agentes", element: <CSSBuyVsOutrosAgentes /> },
  { path: "/cssbuy-dicas-iniciantes", element: <CSSBuyDicasIniciantes /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
